export const config = {
  silent: false,
}
